module.exports = __webpack_public_path__ + "static/media/awards_6.b5e86f3f.jpg";